"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable import/no-cycle */
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const adapter_1 = require("@video/video-client-core/lib/api/adapter");
const context_1 = require("../../../context");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const MultistreamPlayer_1 = tslib_1.__importDefault(require("./MultistreamPlayer"));
const styling_1 = require("../../../styling");
const styles_1 = require("./styles");
const useRefDimensions_1 = require("../../../ui-lib/Hooks/useRefDimensions");
const MultistreamPlayersGrid = (0, mobx_react_lite_1.observer)(({ classes }) => {
    const mergedClasses = (0, styling_1.useStyles)({ target: classes !== null && classes !== void 0 ? classes : {}, source: styles_1.playersWrapperStyles }, "multistream-players-grid");
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    const [render, reRender] = (0, react_1.useState)(false);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<MultistreamPlayersGrid/>");
    const { width, height } = (0, useRefDimensions_1.useRefDimensions)(ctx.playersWrapperElement);
    (0, react_1.useEffect)(() => {
        const updateReRender = () => {
            reRender((prev) => !prev);
        };
        adapter_1.device.addEventListener("resize", updateReRender);
        updateReRender();
        return () => adapter_1.device.removeEventListener("resize", updateReRender);
    }, [width, height]);
    const { playersWrapperElement, activePublicKeys, streams } = ctx;
    return (react_1.default.createElement("div", { ref: playersWrapperElement, className: mergedClasses.root }, activePublicKeys.map((publicKey) => {
        var _a;
        return (react_1.default.createElement(context_1.PlayerUiContext.Provider, { key: publicKey, value: (_a = streams[publicKey]) === null || _a === void 0 ? void 0 : _a.playerUi },
            react_1.default.createElement(MultistreamPlayer_1.default, { publicKey: publicKey, reRender: render })));
    })));
});
exports.default = MultistreamPlayersGrid;
//# sourceMappingURL=MultistreamPlayersGrid.js.map